import {
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@material-ui/core';
import {
  Page as PDFPage,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Text
} from '@react-pdf/renderer';
import React, { FC } from 'react';
import CloseIcon from '@material-ui/icons/Close';

import { formatCurrency } from 'src/utils';
import { ClaimStubReadable } from 'src/types';

const claimStubStyles = StyleSheet.create({
  page: {
    fontFamily: "Courier",
    fontSize: 10,
    padding: 10,
    flexDirection: "column",
    width: "72mm", // thermal paper width ~ 72mm
  },
  center: {
    textAlign: "center",
  },
  line: {
    marginVertical: 2,
  },
  separator: {
    marginVertical: 4,
    textAlign: "center",
  },
  bold: {
    fontWeight: "bold",
  },
  footer: {
    marginTop: 10,
    textAlign: "center",
  },
});

interface Props {
  open: boolean;
  toggleOpen: () => void;
  claimStubHistoryData?: ClaimStubReadable;
}

export const ClaimStubPreviewModal: FC<Props> = ({
  open,
  toggleOpen,
  claimStubHistoryData
}) => {

  return (
    <Dialog maxWidth={'md'} fullWidth open={open}>
      <DialogTitle>
        <Typography variant="h4">Transaction Details</Typography>
        <IconButton
          aria-label="close"
          style={{
            position: 'absolute',
            right: 5,
            top: 5
          }}
          color="secondary"
          onClick={toggleOpen}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Container maxWidth={false}>
      <PDFViewer
        width="100%"
        height="100%"
        style={{ height: '80vh', width: '100%' }}
      > 
      <Document>
        <PDFPage size={{ width: 226, height: 'auto' }} style={claimStubStyles.page}>
          <View>
            <Text style={claimStubStyles.center}>! CLAIM STUB !</Text>
            <Text style={claimStubStyles.center}>PC Worth</Text>
            <Text style={claimStubStyles.center}>{claimStubHistoryData?.store_branch}</Text>

            <Text style={claimStubStyles.line}>
              Transaction No: {claimStubHistoryData?.transaction_no}
            </Text>
            <Text style={claimStubStyles.line}>Order No: {claimStubHistoryData?.order_no}</Text>
            <Text style={claimStubStyles.line}>Date: {claimStubHistoryData?.date_today}</Text>
            <Text style={claimStubStyles.line}>Cashier: {claimStubHistoryData?.cashier_name}</Text>

            <Text style={claimStubStyles.separator}>
              ---------------------------------------
            </Text>

            {claimStubHistoryData?.items.map((item, idx) => (
              <View key={idx} style={{ marginBottom: 4 }}>
                <Text>
                  {item.quantity} x {item.product_name}
                </Text>
                <Text>PHP {formatCurrency(item.retail_price)}</Text>
              </View>
            ))}

            <Text style={claimStubStyles.separator}>
              ---------------------------------------
            </Text>

            <Text>Total Amount: PHP {formatCurrency(claimStubHistoryData?.total_amount)}</Text>
            <Text>Balance: PHP {formatCurrency(claimStubHistoryData?.balance)}</Text>

            {claimStubHistoryData?.payments.map((p, idx) => (
              <Text key={idx}>
                {p.payment_type}: PHP {formatCurrency(p.amount)}
              </Text>
            ))}

            <Text style={claimStubStyles.separator}>
              ---------------------------------------
            </Text>

            <Text style={claimStubStyles.center}>THIS IS NOT A SALES INVOICE</Text>
            <Text style={claimStubStyles.center}>
              The official invoice will be provided once
            </Text>
            <Text style={claimStubStyles.center}>
              your item(s) are released and tested good.
            </Text>

            <View style={claimStubStyles.footer}>
              <Text>Thank you for your patience!</Text>
              <Text>Please keep this claim stub.</Text>
            </View>
          </View> 
        </PDFPage>
      </Document>
      </PDFViewer>
        </Container>
      </DialogContent>
    </Dialog>
  );
};
